import { Phone, Mail, Globe, MapPin, Download, Share2 } from "lucide-react";
import { toast } from "@/components/ui/sonner";

const WHATSAPP_URL = "https://wa.me/447961967908?text=Hello%20ACPZ%20Consultancy%2C%20I%27d%20like%20to%20discuss%20your%20metals%20trading%20services.";

const WhatsAppIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

const ACTIONS = [
  { id: "call", icon: Phone, label: "Call the Desk", value: "+44 7961 967908", href: "tel:+447961967908", accent: false },
  { id: "whatsapp", icon: WhatsAppIcon, label: "WhatsApp", value: "Chat instantly", href: WHATSAPP_URL, accent: true },
  { id: "email", icon: Mail, label: "Email", value: "info@acpzconsultancy.com", href: "mailto:info@acpzconsultancy.com", accent: false },
  { id: "web", icon: Globe, label: "Website", value: "acpzconsultancy.com", href: "https://acpzconsultancy.com", accent: false },
];

export default function VisitingCard() {
  const share = async () => {
    const data = { title: "ACPZ Consultancy Ltd", text: "ACPZ Consultancy Ltd — Physical Metals Trading & Risk Consultancy", url: window.location.href };
    if (navigator.share) {
      try { await navigator.share(data); } catch {}
    } else {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Card link copied to clipboard");
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0D12] text-[#F4F6F8] flex items-center justify-center px-4 py-10 relative overflow-hidden" data-testid="visiting-card">
      <div className="absolute inset-0 technical-grid opacity-50" />
      <div
        className="absolute left-1/2 top-0 -translate-x-1/2 w-[90vw] h-[60vh] rounded-full heat-pulse"
        style={{ background: "radial-gradient(circle, rgba(224,109,40,0.14) 0%, transparent 62%)" }}
      />

      <div className="relative w-full max-w-md">
        <div className="card-industrial !border-[#E06D28]/30 overflow-hidden">
          <div className="h-1.5 w-full bg-gradient-to-r from-[#F3B700] via-[#E06D28] to-[#B84E14]" />
          <div className="p-8 sm:p-10 text-center">
            <img src="/logo-full.png" alt="ACPZ Consultancy Ltd" className="h-24 mx-auto rounded-md" data-testid="vcard-logo" />
            <div className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#F3B700] mt-6">
              Aluminium · Copper · Lead · Zinc
            </div>
            <p className="text-sm text-[#94A3B8] mt-4 leading-relaxed">
              Physical non-ferrous trading, LME/COMEX/SME risk hedging & global container logistics
            </p>

            <div className="mt-8 space-y-3">
              {ACTIONS.map((a) => (
                <a
                  key={a.id}
                  href={a.href}
                  target={a.id === "whatsapp" || a.id === "web" ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  data-testid={`vcard-${a.id}-button`}
                  className="flex items-center gap-4 w-full border border-[#283244] hover:border-[#E06D28]/60 bg-[#0A0D12]/60 rounded-md px-5 py-4 transition-all duration-300 group"
                >
                  <span className={`w-10 h-10 shrink-0 rounded-sm flex items-center justify-center border transition-transform duration-300 group-hover:scale-110 ${
                    a.accent ? "bg-[#25D366]/10 border-[#25D366]/40 text-[#25D366]" : "bg-[#E06D28]/10 border-[#E06D28]/30 text-[#F07D38]"
                  }`}>
                    <a.icon size={18} />
                  </span>
                  <span className="text-left min-w-0">
                    <span className="block font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#64748B]">{a.label}</span>
                    <span className="block font-display font-bold text-sm text-[#F4F6F8] truncate mt-0.5">{a.value}</span>
                  </span>
                </a>
              ))}
            </div>

            <div className="mt-6 flex gap-3">
              <a
                href="/ACPZ.vcf"
                download="ACPZ-Consultancy.vcf"
                data-testid="vcard-save-contact"
                className="flex-1 inline-flex items-center justify-center gap-2 bg-[#E06D28] hover:bg-[#F07D38] text-white font-semibold text-sm px-5 py-3.5 rounded-full transition-all duration-300 hover:shadow-[0_0_30px_rgba(224,109,40,0.4)]"
              >
                <Download size={16} /> Save Contact
              </a>
              <button
                onClick={share}
                data-testid="vcard-share-button"
                className="inline-flex items-center justify-center gap-2 border border-[#283244] hover:border-[#E06D28]/60 text-[#F4F6F8] font-medium text-sm px-5 py-3.5 rounded-full transition-colors duration-300"
              >
                <Share2 size={16} /> Share
              </button>
            </div>

            <div className="mt-8 flex items-center justify-center gap-2 text-[#64748B] text-xs">
              <MapPin size={13} className="text-[#E06D28]" /> United Kingdom
            </div>
          </div>
        </div>
        <p className="text-center font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#475569] mt-6">
          acpzconsultancy.com
        </p>
      </div>
    </div>
  );
}
